import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import TecRmiSvgHtml from "../TecRmiSvgHtml";
import useDidMountEffect from "../../../utils/useDidMountEffect";
import csvPanZoom from "svg-pan-zoom";

const VehicleHtml = props => {
  const ref = useRef();

  useDidMountEffect(() => {
    window.linkIDs = (e) => {}
    window.unlinkIDs = (e) => {}
    window.showToolTip_bg_vehicle = (id, e) => {
      document.body.style.cursor = 'pointer';

      var toolTip = ref?.current?.querySelector('#toolTip')
      if(toolTip){
        toolTip.innerHTML = id;
        toolTip.style.display = 'block';

        var x = e.pageX + 15;
        var y = e.pageY + 15;

        if((x + toolTip.clientWidth + 20) > document.body.clientWidth)
          x = e.pageX - toolTip.clientWidth;
        if((y + 30) > document.body.clientHeight)
          y = e.pageY - 40;

        toolTip.style.left = x + 'px';
        toolTip.style.top = y + 'px';
      }
    }
    window.hideToolTip_bg_vehicle = () => {
      document.body.style.cursor = 'default';
      var toolTip = ref?.current?.querySelector('#toolTip');
      if(toolTip){
        toolTip.style.display = 'none';
        toolTip.innerHTML = '';
      }
    }
    window.clickOnElement_bg_vehicle = id => {
      switch (id.substr(0, 1)) {
        case 'h': {
          props.onMainGroupIdSelect(id.substr(1))

          break;
        }
      }
    }
  })

  return <TecRmiSvgHtml
    ref={ref}
    className={`tec-rmi-body-graphics tec-rmi-body-graphics-vehicle ${props.tecRmiClassName}`}
    html={props.html}
    excludeJsFunctions={[
      'clickOnElement_bg_vehicle',
      'linkIDs',
      'unlinkIDs',
      'showToolTip',
      'hideToolTip',
    ]}
    renameFunctions={{
      clickOnElement: 'clickOnElement_bg_vehicle',
      showToolTip: 'showToolTip_bg_vehicle',
      hideToolTip: 'hideToolTip_bg_vehicle',
    }}
    onDidMount={() => {
      if(ref.current){
        const table = ref?.current?.querySelector('table')

        if(table){
          // table.style.height = '100%'
          const td1 = table.querySelector('.tec-rmi-svg table>tbody>tr>td:nth-child(1)')
          const td2 = table.querySelector('.tec-rmi-svg table>tbody>tr>td:nth-child(2)')
          const td3 = table.querySelector('.tec-rmi-svg table>tbody>tr>td:nth-child(3)')
          if(td1){
            td1.style.width = '100%'
          }
          if(td2){
            td2.remove()
          }
          if(td3){
            td3.remove()
          }
        }

        const svg = table.querySelector('svg')
        if(svg){
          svg.style.height = '230px'
          svg.style.width = '100%'
        }
      }

      csvPanZoom('.tec-rmi-svg svg', {
        zoomScaleSensitivity: 0.25,
        maxZoom: 20,
        minZoom: 0.8,
      })
    }}
  />;
};

VehicleHtml.propTypes = {
  tecRmiClassName: PropTypes.string,
  html: PropTypes.string.isRequired,
  onMainGroupIdSelect: PropTypes.func.isRequired,
};

export default VehicleHtml;